(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/content/shared/game-analysis-filter-utils.js') >= 0) return;  svs.modules.push('/components/content/shared/game-analysis-filter-utils.js');
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

var validTypes = ['cnt:authorProfile', 'cnt:drawAnalysis', 'cnt:gameAnalysis'];
var excludedRootVariables = ['properties', 'parentId', 'parentName', 'rank', 'version'];
var excludedAuthorProfileVariables = [].concat(excludedRootVariables);
var excludedGameAnalysisVariables = [].concat(excludedRootVariables);
var rootRenamePairs = [{
  from: 'domainCategories',
  to: 'gameInfo'
}];
var authorProfileRenamePairs = [{
  from: 'domainCategories',
  to: 'authorInfo'
}];
var gameAnalysisRenamePairs = [{
  from: 'domainCategories',
  to: 'gameAnalysisInfo'
}];

var typeIsValid = function typeIsValid(result) {
  return result ? validTypes.indexOf(result.contentType) > -1 : result;
};

var deepCopyOf = function deepCopyOf(obj) {
  return obj ? JSON.parse(JSON.stringify(obj)) : obj;
};

var excludeVariableIn = function excludeVariableIn(section, variableName) {
  if (section) {
    var copyOfSection = deepCopyOf(section);
    delete copyOfSection[variableName];
    return copyOfSection;
  }
};

var renameVariableIn = function renameVariableIn(json, renamePair) {
  if (json) {
    var jsonStringSplit = JSON.stringify(json).split(renamePair.from);
    var hasVariable = function hasVariable(stringSplit) {
      return stringSplit.length !== 1 || stringSplit[0] !== '';
    };
    return hasVariable(jsonStringSplit) ? JSON.parse(jsonStringSplit.join(renamePair.to)) : null;
  }
};

var kebabToCamel = function kebabToCamel(inString) {
  return inString.replace(/([-_][a-z])/g, function (matches) {
    return matches.toUpperCase().replace('-', '').replace('_', '');
  });
};

var processDomainCategoriesFrom = function processDomainCategoriesFrom(domainCategories) {
  if (Array.isArray(domainCategories)) {
    var copyOfDomainCategories = deepCopyOf(domainCategories);
    var processedDomainCategories = {};
    copyOfDomainCategories.forEach(function (domainCategory) {
      var value = domainCategory.split('/')[1];
      var keyName = kebabToCamel(domainCategory.split('svs-domain-')[1].split('/')[0]);
      if (Array.isArray(processedDomainCategories[keyName])) {
        processedDomainCategories[keyName].push(value);
      } else {
        processedDomainCategories[keyName] = [value];
      }
    });
    return processedDomainCategories;
  }
  return domainCategories;
};

var processAuthorProfileFrom = function processAuthorProfileFrom(authorProfile) {
  authorProfile.domainCategories = processDomainCategoriesFrom(authorProfile.domainCategories);
  excludedAuthorProfileVariables.forEach(function (excludedVariable) {
    authorProfile = excludeVariableIn(authorProfile, excludedVariable);
  });
  return authorProfile;
};

var processGameAnalysis = function processGameAnalysis(gameAnalysis) {
  var processed = _objectSpread(_objectSpread({}, gameAnalysis), {}, {
    domainCategories: processDomainCategoriesFrom(gameAnalysis.domainCategories),
    eventNumber: gameAnalysis.properties.cnt_eventNumber,
    gamePredictions: JSON.parse(gameAnalysis.properties.cnt_gamePrediction)
  });
  excludedGameAnalysisVariables.forEach(function (excludedVariable) {
    delete processed[excludedVariable];
  });
  return processed;
};

var processGameAnalysesFrom = function processGameAnalysesFrom(gameAnalyses) {
  if (gameAnalyses) {
    var processedGameAnalyses = [];
    gameAnalyses.forEach(function (gameAnalysis) {
      processedGameAnalyses.push(processGameAnalysis(gameAnalysis));
    });
    return processedGameAnalyses;
  }
};

var processRenamingOn = function processRenamingOn(result) {
  authorProfileRenamePairs.forEach(function (renamePair) {
    result.authorProfile = renameVariableIn(result.authorProfile, renamePair);
  });
  gameAnalysisRenamePairs.forEach(function (renamePair) {
    result.gameAnalysis = renameVariableIn(result.gameAnalysis, renamePair);
  });
  rootRenamePairs.forEach(function (renamePair) {
    result = renameVariableIn(result, renamePair);
  });
  return result;
};
var exportPayload = {
  deepCopyOf: deepCopyOf,
  typeIsValid: typeIsValid,
  processAuthorProfileFrom: processAuthorProfileFrom,
  processGameAnalysis: processGameAnalysis,
  processGameAnalysesFrom: processGameAnalysesFrom,
  processDomainCategoriesFrom: processDomainCategoriesFrom,
  excludeVariableIn: excludeVariableIn,
  excludedRootVariables: excludedRootVariables,
  processRenamingOn: processRenamingOn,
  validTypes: validTypes
};
if (svs.isServer) {
  module.exports = exportPayload;
} else {
  svs.content.shared.filters.gameAnalysisFilter.gameAnalysisFilterUtils = exportPayload;
}

 })(window);